import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const approveMaintenanceTask = api(async function approveMaintenanceTask(taskId) {
    return mutate(
        gql`
            mutation ApproveMaintenanceTask($taskId: ID!) {
                approveMaintenanceTask(taskId: $taskId) {
                    id
                    heading
                    version
                    draft
                }
            }
        `,
        { taskId },
        { returns: "approveMaintenanceTask" }
    )
})
